import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {AuthState} from '@shared/state/auth/auth.state';
import {Actions, Select, ofActionSuccessful} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {LogoutSuccess} from '@shared/state/auth/auth.actions';
import {LoggerService, LogLevel} from '@app/service/logger/logger.service';
import {takeUntil} from 'rxjs/operators';
import {environment} from '@env';
import * as AOS from 'aos';
import {RoutingService} from '@app/service/routing/routing.service';
import {isPlatformBrowser} from '@angular/common';
import {ConsoleToggleService} from '@shared/service/console-toggle/console-toggle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  @Select(AuthState.getInitialized) initialized$: Observable<boolean>;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  isBrowser: boolean;

  constructor(private logService: LoggerService, private actions: Actions, private routingService: RoutingService,
              @Inject(PLATFORM_ID) platformId: any, private consoleToggleService: ConsoleToggleService) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.consoleToggleService.disableConsoleInProduction();
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      AOS.init({
        duration: 500,
        easing: 'ease-in-out',
        once: true,
        mirror: false
      });
      window.addEventListener('load', AOS.refreshHard());
    }
    this.actions.pipe(ofActionSuccessful(LogoutSuccess))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.routingService.navigateHome();
        if (this.isBrowser) {
          window.location.reload();
        }
      });
    this.logService.level = environment.local ? LogLevel.All : LogLevel.Error;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
